const forEachValue = <T>(
  value: Record<string, T> | T[],
  iteratee: (item: T, key: string | number) => void,
): void => {
  if (Array.isArray(value)) {
    value.forEach((item, index) => iteratee(item, index));
    return;
  }

  Object.keys(value).forEach(key => iteratee(value[key], key));
};

const isNumericKey = (key: string): boolean => /^\d+$/.test(key);

const toPathParts = (path: string): Array<string | number> =>
  path.split('.').map(part => (isNumericKey(part) ? Number(part) : part));

const setPath = (
  object: Record<string, unknown>,
  path: Array<string | number>,
  value: unknown,
): void => {
  let current: Record<string | number, unknown> = object;

  path.forEach((segment, index) => {
    const isLast = index === path.length - 1;

    if (isLast) {
      current[segment] = value;
      return;
    }

    const nextSegment = path[index + 1];
    const shouldBeArray =
      typeof nextSegment === 'number' ||
      (typeof nextSegment === 'string' && isNumericKey(nextSegment));

    if (current[segment] === null || typeof current[segment] !== 'object') {
      current[segment] = shouldBeArray ? [] : {};
    }

    current = current[segment] as Record<string | number, unknown>;
  });
};

export const flattenedToNested = (
  source: Record<string, string>,
  separator = '.',
): Record<string, unknown> => {
  const result: Record<string, unknown> = {};

  forEachValue(source, (value, key) => {
    const path =
      separator === '.'
        ? toPathParts(String(key))
        : String(key)
            .split(separator)
            .map(part => (isNumericKey(part) ? Number(part) : part));
    setPath(result, path, value);
  });

  return result;
};
